/**
 * Cliente HTTP dos critérios adicionados pelo perito na mesa (E38.F3). // ux-neutrality:allow doc-comment
 *
 * Espelha `apps/api/runtime/custom_criteria.py` e // ux-neutrality:allow doc-comment
 * `apps/api/types/custom_criterion.py`. O perito registra um critério fora dos // ux-neutrality:allow doc-comment
 * 10 canônicos (nome + LR assinado + observação); o `status` vem DERIVADO da // ux-neutrality:allow doc-comment
 * banda do LR pelo backend (single-source). Sai no laudo em paralelo aos 10. // ux-neutrality:allow doc-comment
 */
import type { AxiosInstance } from 'axios';
import type { CriterionBandStatus } from '@/lib/case_workspace';

export interface CustomCriterionData {
  id: string;
  case_analysis_id: string;
  name: string;
  lr: number;
  status: CriterionBandStatus;
  observation: string | null;
  created_at: string;
}

export interface CustomCriterionCreateData {
  name: string;
  lr: number;
  observation?: string | null;
}

const BASE = (caseId: string, analysisId: string): string =>
  `/casos/${caseId}/analyses/${analysisId}/custom-criteria`;

/** GET: critérios custom da análise em ordem de criação. */
export async function listCustomCriteria(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
): Promise<CustomCriterionData[]> {
  const { data } = await client.get<CustomCriterionData[]>(BASE(caseId, analysisId));
  return data;
}

/** POST: adiciona um critério do perito (201). */
export async function createCustomCriterion(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  input: CustomCriterionCreateData,
): Promise<CustomCriterionData> {
  const { data } = await client.post<CustomCriterionData>(BASE(caseId, analysisId), input);
  return data;
}

/** DELETE: remove um critério custom (204). */
export async function deleteCustomCriterion(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  criterionId: string,
): Promise<void> {
  await client.delete(`${BASE(caseId, analysisId)}/${criterionId}`);
}
